import React, { Component } from 'react';
import { Avatar } from 'antd';
import { Link } from 'react-router-dom';
import { dateDifferenceShorted } from '../../../utils/helpers';
import ImageApi from '../../../api/image';
import UserPlaceholder from '../../../assets/images/user_placeholder.svg';
import { connect } from 'react-redux';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {sendFeedbackRequest} from "../../../actionCreators/feedActions";
import SendFeedback from "../../SendFeedback";

class WorshipLocationDetailsHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
      imageUrl: '',
      showErrors: false,
      feedbackModalOpen: false,
    };
  }

  componentDidMount() {
    if (!this.props.author.image || !this.props.author.image.thumbnailUrl) return;

    ImageApi.getImage(this.props.author.image.thumbnailUrl).then((imageUrl) => {
      this.setState({ imageUrl });
    });
  }

  toggleMenu = () => {
    this.setState({ menuOpen: !this.state.menuOpen });
  };

  toggleFeedbackModal = () => {
    this.setState({
      feedbackModalOpen: !this.state.feedbackModalOpen
    })
  }

  render() {
    const { author, createdAt, link } = this.props;

    return (
      <div className={`worship-details-item-header d-flex align-items-center`}>
        <SendFeedback isOpen={this.state.feedbackModalOpen} item={{postable_id: this.props.worshipId, postable_type: 'worship'}} sendFeedback={this.props.sendFeedback} toggleOpen={this.toggleFeedbackModal} />

        <Avatar
          shape="square"
          className="worship-details-item-header-image"
          src={this.state.imageUrl || UserPlaceholder}
          icon="user"
          size={42}
        />

        <div className="worship-details-item-header-content d-flex flex-column flex-fill">
          <div className="d-flex justify-content-between">
            <p className="worship-details-item-header-text">
              <Link className="worship-details-item-header-text" to={`/users/${author.id}`}>
                {author.first_name} {author.last_name}
              </Link>
            </p>
          </div>

          <Link to={link} className="worship-details-item-header-time">
            {dateDifferenceShorted(createdAt)}
          </Link>
        </div>

        <div>
          <Dropdown isOpen={this.state.menuOpen} direction="left" toggle={this.toggleMenu}>
            <DropdownToggle
                tag="span"
                data-toggle="dropdown"
                aria-expanded={this.state.menuOpen}
            >
              <FontAwesomeIcon
                  className="community-item-header-collapse"
                  icon={['fas', 'chevron-down']}
              />
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={this.toggleFeedbackModal}>Send Feedback</DropdownItem>
              <DropdownItem onClick={this.toggleCancelConfirmModal}>Cancel</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    );
  }
}

export default connect(
  (state, props) => ({
    currentUser: state.currentUser,
  }),
  (dispatch) => ({
    sendFeedback: (payload) => dispatch(sendFeedbackRequest(payload)),
  }),
)(WorshipLocationDetailsHeader);
